module.exports = __webpack_public_path__ + "img/download (1).c0a62240.jpeg";